import React, {useContext} from 'react';
import TruncatedText from '@core/scripts/components/truncated-text';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {Typography, useBreakpointUp} from '@bonprix/design-system';
import {PriceFallback} from '@shopping-funnel/scripts/components/fallbacks/PriceFallback.jsx';
import {useAlpiSwatchOuterGap} from '@article-overview/components/hooks/use-alpi-swatch-outer-gap.ts';
import DesyPriceWrapper from '@shopping-funnel/scripts/components/DesyPriceWrapper.jsx';

function AlpiInformation({title, onAlpiInformationClick, price}) {
    const {browser} = useContext(articleOverviewStaticContext);
    const breakpointXxlUp = useBreakpointUp('xxl');
    const outerGap = useAlpiSwatchOuterGap();

    const renderAlpiTitle = () => {
        const oldBrowser = browser === 'IE';

        return (
            <div className="alpi__title" onClick={onAlpiInformationClick}>
                <TruncatedText className="alpi__truncated" oldBrowser={oldBrowser} lines={2}>
                    <Typography variant={breakpointXxlUp ? 'h5' : 'body1'} component="span" color="primary">
                        {title}
                    </Typography>
                </TruncatedText>
            </div>
        );
    };
    const renderAlpiPrice = () => {
        return (
            <section className="alpi__price-wrapper" onClick={onAlpiInformationClick}>
                <PriceFallback price={price.currentPrice}>
                    <DesyPriceWrapper priceComponentModel={price} size={breakpointXxlUp ? 'large' : 'small'} />
                </PriceFallback>
            </section>
        );
    };
    return (
        <div style={{paddingLeft: `${outerGap / 2}px`}} className={'mt-2'}>
            {renderAlpiTitle()}
            {renderAlpiPrice()}
        </div>
    );
}

export default AlpiInformation;
